import styled from "styled-components";

export const StyledBuyplanDetailsContainer = styled.div`
  .grid-wrapper {
    margin-top: 20px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
    border: 1px solid #e5e7eb;
  }

  .spare-parts-grid {
    width: 100%;
    height: 500px;

    .ag-root-wrapper {
      border: none !important;
      border-radius: 0;
      height: 100%;
    }

    .ag-root {
      border: none;
      border-radius: 0;
    }

    .ag-header {
      background: linear-gradient(to bottom, #f9fafb 0%, #f3f4f6 100%);
      font-weight: 600;
      border-bottom: 2px solid #e5e7eb;
      
      .ag-header-cell {
        padding: 10px 12px;
        font-size: 0.8125rem;
        color: #374151;
        letter-spacing: 0.01em;
      }

      .ag-header-cell:not(.ag-header-cell-auto-height) .ag-header-cell-comp-wrapper {
        height: auto !important;
      }
    }

    .ag-header-cell,
    .ag-cell {
      border-right: 1px solid #f0f0f0;
    }

    .ag-header-cell:last-child,
    .ag-cell:last-child {
      border-right: none;
    }

    .ag-cell {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      font-size: 0.8125rem;
      color: #1f2937;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* text-overflow has no effect on a flex container's own text, so this
       column reverts to a block box (ag-grid's default) to get real ellipsis */
    .ag-cell.part-description-cell {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ag-row {
      border-bottom: 1px solid #f3f4f6;
      transition: background-color 0.15s ease;
    }

    .ag-row:last-child {
      border-bottom: none;
    }

    .ag-row-even {
      background-color: #ffffff;
    }

    .ag-row-odd {
      background-color: #fafbfc;
    }

    .ag-row:hover {
      background-color: #f0f9ff !important;
      cursor: pointer;
    }

    .actions-cell {
      display: flex;
      gap: 6px;
      justify-content: center;

      .btn {
        padding: 4px 8px;
        font-size: 0.75rem;
        border-radius: 4px;
        transition: all 0.2s ease;
        
        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  /* ================= GRID FOOTER ================= */
  .grid-footer {
    background: linear-gradient(to top, #f9fafb 0%, #ffffff 100%);
    border-top: 1px solid #e5e7eb;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .total-rows-label {
      font-size: 0.8125rem;
      color: #6b7280;
      font-weight: 500;
      
      strong {
        font-weight: 700;
        color: #1f2937;
        margin-left: 4px;
      }
    }
  }

  .modal-content {
    padding: 10px;
    border-radius: 10px;
  }

  .parent-products-modal-body {
    padding: 10px !important;
  }
`;